<template>
  <labeled-form-control label="Gender" :optional="true">
    <div class="d-flex">
      <input v-model="genderId" :value="2" type="radio" :disabled="disabled"/><span class="ml-2">Male</span>
      <input v-model="genderId" :value="3" type="radio" :disabled="disabled" class="ml-4"/><span class="ml-2">Female</span>
    </div>
  </labeled-form-control>
</template>

<script>
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetGender',
  props: {
    value: Number,
    disabled: Boolean
  },
  computed: {
    genderId: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
